import { Link } from 'react-router-dom';
import Icon from './Icon.jsx';

/**
 * Frame shared by every signed-out screen.
 *
 * A single centred column at every width. The column — not the card — owns the
 * width, so anything passed as `below` (a trust strip, a footnote) lines up with
 * the card's edges and shares its vertical rhythm. That is what stops a short
 * form from reading as one small box adrift on a large page.
 */
export default function AuthShell({ children, back, maxWidth, wide = false, below }) {
  return (
    <div className="auth-wrap">
      <div className="auth-main">
        <div
          className={`auth-stack${wide ? ' auth-stack-wide' : ''}`}
          style={maxWidth ? { maxWidth } : undefined}
        >
          <div className="auth-card">
            {back && (
              <Link to={back.to} className="back-link">
                <Icon name="arrow-left" />
                {back.label || 'Back'}
              </Link>
            )}
            {children}
          </div>
          {below}
        </div>
      </div>
    </div>
  );
}

/** Brand lockup + title block used at the top of each auth card. */
export function AuthHead({ title, subtitle }) {
  return (
    <div className="auth-head">
      <div className="brand">
        <span className="brand-mark" aria-hidden="true">
          <Icon name="plus" strokeWidth={3} />
        </span>
        <span>
          Heal<em>At</em>Home
        </span>
      </div>
      {title && <h1>{title}</h1>}
      {subtitle && <p>{subtitle}</p>}
    </div>
  );
}

/**
 * Compact reassurance row shown under the sign-in card. Product facts, not
 * testimonials — it fills the space below a short form and answers the question
 * a first-time visitor actually has before typing anything.
 */
export function TrustStrip() {
  const items = [
    { icon: 'shield-check', text: 'Licence-verified nurses' },
    { icon: 'clock', text: 'Confirmed in minutes' },
    { icon: 'cash', text: 'Pay cash after the visit' },
  ];
  return (
    <ul className="trust-strip">
      {items.map((i) => (
        <li key={i.text}>
          <Icon name={i.icon} />
          {i.text}
        </li>
      ))}
    </ul>
  );
}
